@if (client$ | async; as client) {
  @if (prestatiesPage$ | async; as prestaties) {
    @if (thuisverzorgers$ | async; as thuisverzorgers) {
      <zah-client-header label="Prestaties"
        [client]="client">
      </zah-client-header>
      <div class="prestaties">
        <zah-prestaties [initialPageRequest]="initialPageRequest"
          [prestatiesPage]="prestaties"
          [thuisverzorgers]="thuisverzorgers"
          (prestatieClicked)="navigateToPrestatie(client, $event)"
          (pageChange)="onPageChange(client, $event)">
        </zah-prestaties>
      </div>
      <button mat-mini-fab
        color="primary"
        class="back-button"
        (click)="navigateToClient(client)">
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
  }
}
